<template>
  <div class="login">
    <section class="left-panel">
      <header>
        <div class="grid-container top">
          <div class="col-4">
            <img class="logo" src="../assets/images/global/logo.svg">
            <router-link class="btn bg-three active" to="register">Sign Up</router-link>
          </div>
        </div>
      </header>
      <div class="grid-container">
        <div class="col-4 vertical-centre">
          <div class="left-panel-centre">
            <h1>Log In To PEI ex<span>Change</span></h1>
<!--             <span>Chat id: {{ this.$route.params.addtochat }}</span> -->
            <form @submit.prevent="login">
              <input :class="{ error: hasEmailError }" type="email" v-model.trim="email" :placeholder="emailMessage" @keydown="resetError" />
              <input :class="{ error: hasPasswordError }" type="password" pattern=".{6,}" v-model.trim="password" :placeholder="passwordMessage" @keydown="resetError" />
              <router-link to="forgot-password" class="link green">Forgot Password?</router-link>
              <input class="btn btn-big bg-three active" type="submit" value="Log In">
            </form>
          </div>
        </div>
        <ul class="bottom">
          <li><a target="_blank" href="http://planetearthinstitute.org.uk" class="link blue">Visit PEI Website</a></li>
          <li><router-link to="terms" class="link navy">Terms &amp; Conditions</router-link></li>
        </ul>
      </div>
    </section>
    <section class="hero-image">
    </section>
  </div>
</template>

<script>
import { auth } from '@/firebase'
import router from '@/router'

export default {
  data () {
    return {
      email: '',
      password: '',
      hasPasswordError: false,
      hasEmailError: false,
      passwordMessage: '************',
      emailMessage: 'someone@example.com',
      addtochat: this.$route.params.addtochat
    }
  },
  methods: {
    login () {
      let parent = this
      auth.signInWithEmailAndPassword(this.email, this.password)
        .then(function (user) {
          console.log(user.uid)
          router.push('matches')
        })
        .catch(function (err) {
          // Handle errors
          console.log(err.code)
          if (err.code === 'auth/wrong-password') {
            parent.password = ''
            parent.hasPasswordError = true
            parent.passwordMessage = 'Password incorrect. Please try again.'
          }
          if (err.code === 'auth/user-not-found') {
            parent.email = ''
            parent.password = ''
            parent.hasEmailError = true
            parent.emailMessage = 'This user does not exist. Try again.'
          }
          if (err.code === 'auth/too-many-requests') {
            parent.email = ''
            parent.password = ''
            parent.hasEmailError = true
            parent.emailMessage = 'Too many login attempts. Try again later.'
          }
        })
    },
    resetError () {
      this.hasPasswordError = false
      this.hasEmailError = false
      this.passwordMessage = '************'
      this.emailMessage = 'someone@example.com'
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?de335720